export default __webpack_public_path__ + "static/media/97_QT_Header_3.d6430e5e.png";